import React from 'react';
import Field from '../../../fields/Field';
import FieldNumber from '../../../fields/FieldNumber';
import FieldCheckbox from '../../../fields/FieldCheckbox';
import { getTranslation } from '../../../../lang/main';

const FORM_LABEL = {
    Title: getTranslation('FIELD.CARTRULE_TITLE'),
    Discount: `${getTranslation('FIELD.CARTRULE_DISCOUNT')} %`,
    MinimumAmount: getTranslation('FIELD.CARTRULE_MIN_AMOUNT'),
    Enabled: getTranslation('FIELD.CARTRULE_ENABLED'),
};

function CreateCartRuleFields(props) {
    const {
        fieldRefs,
        formData,
        bindUpdateFormData,
        bindUpdateFormDataNumber,
        updateFormData,
    } = props;

    return (
        <React.Fragment>
            <div className='row row--small'>
                <div className='col-xs-12 col-sm-12'>
                    <Field
                        ref={(r) => (fieldRefs.Title = r)}
                        required
                        label={FORM_LABEL['Title']}
                        animatedLabel={FORM_LABEL['Title']}
                        name='Title'
                        value={formData.Title}
                        onChange={bindUpdateFormData}
                    />
                </div>
            </div>

            <div className='row row--small'>
                <div className='col-xs-12 col-sm-6'>
                    <FieldNumber
                        ref={(r) => (fieldRefs.Discount = r)}
                        required
                        strict
                        parseIntDisable={true}
                        allowDecimals={true}
                        allowNegative={false}
                        min={0}
                        max={100}
                        label={FORM_LABEL['Discount']}
                        animatedLabel={FORM_LABEL['Discount']}
                        name='Discount'
                        value={formData.Discount}
                        onChange={bindUpdateFormData}
                    />
                </div>
                <div className='col-xs-12 col-sm-6'>
                    <FieldNumber
                        ref={(r) => (fieldRefs.MinimumAmount = r)}
                        required
                        strict
                        parseIntDisable={true}
                        allowDecimals={true}
                        allowNegative={false}
                        min={0}
                        label={FORM_LABEL['MinimumAmount']}
                        animatedLabel={FORM_LABEL['MinimumAmount']}
                        name='MinimumAmount'
                        value={formData.MinimumAmount}
                        onChange={bindUpdateFormData}
                    />
                </div>
            </div>
            <FieldCheckbox
                ref={(r) => (fieldRefs.Enabled = r)}
                checked={formData.Enabled}
                label={FORM_LABEL['Enabled']}
                name={FORM_LABEL['Enabled']}
                value={formData.Enabled}
                onChange={(e) => {
                    let result = e.target.value == 'false' ? false : true;
                    updateFormData(e.target.name, !result);
                }}
            />
        </React.Fragment>
    );
}

export default CreateCartRuleFields;
